import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import * as settingsActions from "store/entities/settingsInfo/action";

import logger from "utils/logger";
import { useDispatch, useSelector } from "react-redux";
import useLoginInfo from "hooks/useLoginInfo";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import validate from "utils/validate";
import { ButtonLoader, Input } from "components/__new/common/form";

import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const CreateYourPassword = () => {
    const history = useHistory();
    const {userInfo} = useLoginInfo();
    const { token } = useParams();
    const dispatch = useDispatch();
const { acceptInviteLoading, acceptInvite  } = useSelector(state => state.entities.settingsInfo)

    const [form, setForm] = useState({
        password: "",
        confirmPassword: "",
    })
    
    const [isCreated, setIsCreated] = useState(false)
    const [authToken, setAuthToken] = useState(false)
    
    const [pwdShown, setPwdShown] = useState(false);
    const [confirmPwdShown, setConfirmPwdShown] = useState(false);
    
    const [lengthValid, setLengthValid] = useState(false);
    const [lowerCaseValid, setLowerCaseValid] = useState(false);
    const [upperCaseValid, setUpperCaseValid] = useState(false);
    const [characterValid, setCharacterValid] = useState(false);
    const [numberValid, setNumberValid] = useState(false);
    const [formErrors, setFormErrors] = useState({
        password: null,
        confirmPassword: null,
    })
    
        
    const LOWER_CASE_REGEX = /(?=.*[a-z])/;
    const UPPER_CASE_REGEX = /(?=.*[A-Z])/;
    const NUMBER_REGEX = /(?=.*[0-9])/;
    const SPECIAL_CHARACTER_REGEX = /[^A-Za-z0-9]/;
    const EIGHT_CHARACTERS_REGEX = /(?=.{8,})/;
    
    const passwordProps = [
        {
            text: "Be at least 8 characters in length",
            isValid: lengthValid,
        },
        {
            text: "Contain at least one lower case character",
            isValid: lowerCaseValid
        },
        {
            text: "Contain at least one upper case character",
            isValid: upperCaseValid
        },
        {
            text: "Contain at least one special character",
            isValid: characterValid
        },
        {
            text: "Contain at least one number",
            isValid: numberValid
        }
    ]
    
    const validatePassword = (password) => {
        setForm({...form, password});
        
        if(EIGHT_CHARACTERS_REGEX.test(password)) {
            setLengthValid(true);
        } else {
            setLengthValid(false);
        }
        
        if(LOWER_CASE_REGEX.test(password)) {
            setLowerCaseValid(true);
        } else {
            setLowerCaseValid(false);
        }
        
        if(UPPER_CASE_REGEX.test(password)) {
            setUpperCaseValid(true);
        } else {
            setUpperCaseValid(false);
        }
        
        if(SPECIAL_CHARACTER_REGEX.test(password)) {
            setCharacterValid(true);
        } else {
            setCharacterValid(false);
        }
        
        if(NUMBER_REGEX.test(password)) {
            setNumberValid(true);
        } else {
            setNumberValid(false);
        }
    }
    
    const submitDisabled = !lengthValid || !lowerCaseValid || !upperCaseValid || !characterValid || !numberValid || form?.password !== form?.confirmPassword
    
    const handlePasswordChange = (e) => {
        const {name, value} = e.target
        
        if(value && value !== form?.password) {
            setFormErrors({
                ...formErrors,
                confirmPassword: "Passwords do not match",
            })
        } else{
            setFormErrors({
                ...formErrors,
                confirmPassword: null,
            })
        }
        
        setForm({
            ...form,
            [name]: value
        })
        
    }

    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            dispatch(settingsActions.acceptInvite({password: form.password}, authToken));
            setIsCreated(true);
        }
    }

    
    const togglePwdShown = () => {
        setPwdShown(!pwdShown)
    }
    
    const toggleConfirmPwdShown = () => {
        setConfirmPwdShown(!confirmPwdShown)
    }

    
    useEffect(() => {
        if (acceptInvite?.error === false && isCreated === true){
            setIsCreated(false)
            history.push("/create-your-password/member/success");
            // logger("employer-create-your-password", userInfo);
        }
        // eslint-disable-next-line
    }, [acceptInvite])

    useEffect(() => {
        setAuthToken(token)
    }, [token]);

    return (
        <>

            <DynamicHeadTag
                headerText="Create Your Password"
            />

            <div className="p-8">
                <div>
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold">
                            Create Your Password
                        </div>
                    </div>

                    <div>
                        <div>

                            <div className="mt-10 w-full max-w-md mx-auto md:mx-0 lg:w-96">

                                <form onSubmit={submitForm}>
                                    <div className="relative">
                                        <Input
                                            type={pwdShown ? "text" : "password"} 
                                            label="Enter Password"
                                            autoComplete="off"
                                            name="password"
                                            value={form.password}
                                            placeholder="Enter a password"
                                            onChange={(e) => validatePassword(e.target.value)}
                                        />
                                        
                                        <div className="absolute top-8 right-2">
                                            {pwdShown ? <EyeRevealed onClick={togglePwdShown} /> :  <EyeMasked onClick={togglePwdShown} />}
                                        </div>
                                    </div>
                                    
                                    <div className="relative">
                                        <Input
                                            disabled={!lengthValid || !lowerCaseValid || !upperCaseValid || !characterValid || !numberValid}
                                            autoComplete="off"
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            placeholder="Confirm password"
                                            value={form.confirmPassword}
                                            type={confirmPwdShown ? "text" : "password"} 
                                            // onChange={(e) => setForm({...form, confirmPassword: e.target.value})}
                                            onChange={handlePasswordChange} 
                                            tagText={formErrors?.confirmPassword}
                                        />
                                        
                                        <div className="absolute top-8 right-2">
                                            {confirmPwdShown ? <EyeRevealed onClick={toggleConfirmPwdShown} /> :  <EyeMasked onClick={toggleConfirmPwdShown} />}
                                        </div>
                                    </div>
                                    
                                    <div className="pb-6">
                                        <p style={{fontWeight: 400, fontSize: '16px', lineHeight: '19.2px', color: '#0D0C2B'}} className='mb-2'></p>
                                        {passwordProps.map(({text, isValid}) => (
                                            <div key={text} className="w-full mb-1 flex items-center">
                                                <span>
                                                    <FontAwesomeIcon 
                                                        icon={isValid ? "check-circle" : "times-circle"} 
                                                        className={`text-sm transition-all duration-200 ${isValid ? "text-green-500" : "text-red-500"}`}
                                                        />
                                                </span>
                                                <p className={`text-sm mb-0 ml-2 transition-colors duration-200 ${isValid ? "text-green-500" : "text-red-500"}`}>
                                                    {text}
                                                </p>
                                            </div>
                                        ))}
                                    </div>                             

                                    <ButtonLoader
                                        type="submit"
                                        disabled={submitDisabled}
                                        loading={acceptInviteLoading}
                                        className="btn btn-lg btn-block btn-ep-primary disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                                            Continue
                                    </ButtonLoader>
                                    
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
        </>
    )
}
 

export default CreateYourPassword;